// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import watchReportsOperations from './operations'

export default function *main (): Generator<*, *, *> {
  yield fork(watchReportsOperations)
}

